import {
  createActions, asyncInitialState, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null
}, 'ldInTransitLocalShipments');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: 'LineDetails',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Shipment', field: 'Shipment', minWidth: 150, suppressSorting: true },
    { headerName: 'Delivery W/H', field: 'Warehouse', minWidth: 150, suppressSorting: true },
    { headerName: 'ETA', field: 'ETA', suppressSorting: true, minWidth: 150 },
    { headerName: 'In transit', field: 'QtyIntransitDisplay', type: 'numericColumn', suppressSorting: true, minWidth: 150 },
    { headerName: 'Freight type', field: 'FreightType', suppressSorting: true, minWidth: 150 },
    { headerName: 'Carrier', field: 'Carrier', suppressSorting: true, minWidth: 150 },
    { headerName: 'Description', field: 'Description', minWidth: 150 },
    { headerName: 'Delivery W/H Name', field: 'DeliveryWHName', suppressSorting: true, minWidth: 150 },
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.purchaseOrderEnquiry.ldInTransitLocalShipments,
  {
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.purchaseOrderEnquiry.ldInTransitLocalShipments.loading,
  gridOptions: state => state.purchaseOrderEnquiry.ldInTransitLocalShipments.data.gridOptions,
  Columns: state => state.purchaseOrderEnquiry.ldInTransitLocalShipments.data.Columns,
  Actions: state => state.purchaseOrderEnquiry.ldInTransitLocalShipments.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)